import React, { useContext } from "react";

import "./cart-change-style.scss";
import { DeviceContext, deviceType, } from "@src/providers";

import MaccaronLogo from "@src/imagesNew/logo/cart-maccaron-logo.png";
import MgsLogo from "@src/imagesNew/logo/new-mgs-logo.png";

import Typography from "@src/componentsNew/Typography/Typography";
import ExpandMoreIcon from "@src/componentsNew/Icons/Icons/ExpandMoreIcon";
import ExpandLessIcon from "@src/componentsNew/Icons/Icons/ExpandLessIcon";

interface IProps {
  hasBorder: boolean;
  activeCart: 'maccaron' | 'mgs';
  lineCount: number;
  onClickHandler?: () => void;
}

const CartChange = ({ hasBorder, activeCart, lineCount, onClickHandler }: IProps) => {
  const { isMobile } = useContext<deviceType>(DeviceContext);

  return (
    hasBorder ?
      // activeCart와 반대되는 영역
      <div id="change-cart-border-wrapper" className={`${activeCart} ${isMobile ? "mobile" : ""}`} onClick={onClickHandler}>
        <div className={`change-cart-inner-wrapper ${isMobile ? "mobile" : ""}`}>
          <div className="logo-wrapper">
            <img src={activeCart === 'maccaron' ? MgsLogo : MaccaronLogo} alt="logo" width={activeCart === 'maccaron' ? '58' : '90'} />
            {
              activeCart === 'maccaron' && (
                <Typography cName="global-store-text" variant="body2" component="span" style={{ color: "#9E9E9E" }}>
                  Global Store
                </Typography>
              )
            }
          </div>

          <div className="change-cart-quantity-wrapper">
            <Typography cName={`quantity-count ${activeCart}`} variant="body2" component="span">
              {lineCount}
            </Typography>

            <ExpandMoreIcon />
          </div>
        </div>
      </div>
      :
      // activeCart와 일치하는 영역
      <div id="change-cart-none-border-wrapper" className={`${isMobile ? 'mobile' : ''}`} onClick={onClickHandler}>
        <div className="logo-wrapper">
          <img src={activeCart === 'maccaron' ? MaccaronLogo : MgsLogo} alt="logo" width={activeCart === 'maccaron' ? '90' : '58'} />
          {
            activeCart === 'mgs' && (
              <Typography cName="global-store-text" variant="body2" component="span" style={{ color: "#9E9E9E" }}>
                Global Store
              </Typography>
            )
          }
        </div>

        <div className="change-cart-quantity-wrapper">
          <Typography cName={`quantity-count ${activeCart}`} variant="body2" component="span">
            {lineCount}
          </Typography>

          <ExpandLessIcon />
        </div>
      </div>
  )
}

export default CartChange;
